export default "__VITE_ASSET__PHvRJ_JN__"